import { PureComponent } from "react";
import { ChartTooltips, ChartWrapper, ViewMoreBtnRow, ChartFooter } from "./styles/common.styled";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import useMediaQuery from "@mui/material/useMediaQuery";
import { ChartDataTypes } from "../types";
import { REPs } from "../config";
import { Button } from "@mui/material";
import moment from "moment";
import { useLocation } from "react-router-dom";
const tooltipStyles = {
    cursor: {
        fill: 'transparent'
    },
}

const hostRep = REPs.filter(val => val.host === true)[0];
const ww = window.innerWidth;

export const CompareChart = ({ chartData, handleSignUp, handleShowPlan }: {
    chartData: ChartDataTypes[] | undefined,
    handleSignUp: Function,
    handleShowPlan: Function
}) => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    
    // Determine if we have only two competitors for compact layout
    const isTwoCompetitors = chartData && chartData.length === 2;
    
    if (!chartData) return null;
    return (
        <>
            <ChartWrapper isTwoCompetitors={isTwoCompetitors}>
                <ResponsiveContainer>
                    <BarChart
                        data={chartData}
                        margin={{ 
                            top: 30, 
                            bottom: 30, 
                            left: isTwoCompetitors ? -20 : -36,
                            right: isTwoCompetitors ? 20 : 0
                        }}
                    >
                        <YAxis  stroke="#fff"   tick={false} axisLine={false} />
                        <XAxis dataKey="id" stroke="#bbb"  />
                        <Tooltip
                            {...tooltipStyles}
                            position={{ y: 150 }}
                            wrapperStyle={{ zIndex: 1 }}
                            content={<CustomTooltip />}
                        />
                        <Bar dataKey="value"
                            isAnimationActive={true}
                            maxBarSize={80}
                            shape={BarWithTopBorder()}
                            label={<CustomizedLabel />}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </ChartWrapper>
            <ViewMoreBtnRow isTwoCompetitors={isTwoCompetitors}>
                {
                    chartData.map((val, idx) => (
                        <div key={idx} className={idx === 0 ? "buttons-section" : "buttons-section"}>
                            <img style={val.id === "196" ? { height: "40px" } : {}} src={val.id === "196" ? "/images/logo.png" : `https://www.powerlego.com/ApiGateway/v2/logo/provider/${val.id}`}/>
                            <Button
                                size="small"
                                variant="text"
                                className="text-button"
                                onClick={() => handleShowPlan(val.id, val.planName)}
                                title={val.planName || val.label}
                            >
                               {isMobile ? "View Plan" : val.planName}
                            </Button>
                            {idx === 0  && <Button onClick={() => {
                                handleSignUp(val.id);
                            }} size="medium" variant="secondary" style={{padding:"8px 10px"}} className="signup-button">
                                Sign Up
                            </Button>}
                        </div>
                    ))
                }
            </ViewMoreBtnRow>
            <Button
                onClick={() => { 
                    handleSignUp(chartData[0].id);
                }}
                size={ww < 600 ? "large" : "small"}
                variant="secondary"
                sx={{
                    width: { xs: "100%", sm: "auto" },
                    display: "block",
                    mx: { xs: 0, sm: "auto" }, // center on larger screens
                    my: 1,
                    minWidth: { sm: 220 }, 
                    padding:{sm:"16px 28px", xs:"8px 0px"},
                    fontSize:{sm: "16px"}
                }}
            >
                Sign up with Constellation
            </Button>
            <ChartFooter>Last scan date: {moment().isBetween(moment('00:00am', 'hh:mma'), moment('01:00am', 'hh:mma')) ? moment().subtract(1, 'days').format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')}</ChartFooter>
        </>
    )
}

const BarWithTopBorder = () => {
    return (props: any) => {
        const { x, y, width, height, id } = props;

        let isHost = false;
        if (hostRep && hostRep.providerId === id) isHost = true;

        return (
            <g>
                <rect x={x} y={y} width={width} height={height} stroke="none" className="bar" rx="4" ry="4" fill={isHost ? "#2372B9" : "#ddd"} />
            </g>
        )
    }
}

class CustomTooltip extends PureComponent {
    render() {
        const { active, payload }: Readonly<any> = this.props;

        if (!active || !payload || !payload[0]) return null;
        const { label, value } = payload[0].payload;

        return (
            <ChartTooltips>
                <h6>{label}</h6>
                <p>{value?.toFixed(1)}¢</p>
            </ChartTooltips>
        )
    }
}

class CustomizedTick extends PureComponent {
    render() {
        const { x, y, payload, width, visibleTicksCount }: Readonly<any> = this.props;
        const maxWidth = 125;
        const _width = width / visibleTicksCount > maxWidth ? maxWidth : width / visibleTicksCount;
        return (
            <g transform={`translate(${x},${y})`}>
                <image
                    x={_width / 2 * -1}
                    y={0}
                    xlinkHref={payload.value === "196" ? "/images/logo.png" : `https://www.powerlego.com/ApiGateway/v2/logo/provider/${payload.value}`}
                    width={_width}
                    className={payload.value === "196" ? "chart-logo" : ""}
                />
            </g>
        )
    }
}

class CustomizedLabel extends PureComponent {
    render() {
        const { x, y, value, width }: Readonly<any> = this.props;
        return (
            <text
                x={x + width / 2}
                y={y}
                dy={-8}
                fill='#3a3a3a'
                fontSize={width / 4}
                fontWeight="700"
                textAnchor="middle"
            >
                {value?.toFixed(1)}¢
            </text>
        )
    }
}